import { z } from 'zod';

import { idSchema, isoDateTimeSchema, slugSchema } from './common.js';

/**
 * Termo de glossário (PPPs/Concessões). Slug é PK (URL-friendly,
 * kebab-case minúsculo). `relacionados` é array de slugs.
 */
export const glossaryTermSchema = z.object({
  slug: slugSchema,
  termo: z.string().min(1).max(120),
  definicaoHtml: z.string().min(1),
  relacionados: z.array(slugSchema),
  publicado: z.boolean(),
  criadoEm: isoDateTimeSchema,
  atualizadoEm: isoDateTimeSchema,
});
export type GlossaryTerm = z.infer<typeof glossaryTermSchema>;

export const createGlossaryTermInputSchema = z.object({
  slug: slugSchema,
  termo: z.string().min(1).max(120),
  definicaoHtml: z.string().min(1),
  relacionados: z.array(slugSchema).max(20).optional(),
  publicado: z.boolean().optional(),
});
export type CreateGlossaryTermInput = z.infer<typeof createGlossaryTermInputSchema>;

export const updateGlossaryTermInputSchema = createGlossaryTermInputSchema
  .partial()
  .omit({ slug: true });
export type UpdateGlossaryTermInput = z.infer<typeof updateGlossaryTermInputSchema>;

export const listGlossaryTermsQuerySchema = z.object({
  q: z.string().max(120).optional(),
  publicado: z.preprocess(
    (v) => (v === 'true' ? true : v === 'false' ? false : undefined),
    z.boolean().optional(),
  ),
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(200).default(100),
});
export type ListGlossaryTermsQuery = z.infer<typeof listGlossaryTermsQuerySchema>;
